import { features } from '@kdcloudjs/table';

function useContextMenu(pipeline, contextMenu) {
  if (contextMenu) {
    pipeline.use(features.contextMenu(contextMenu === true ? {} : contextMenu));
  }
}

export default useContextMenu;